import './css/common.css'
import './css/app.css'
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import { useDispatch, useSelector } from 'react-redux';
import { change_Current_Location, changeHeaderTitle } from '../store';
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import { Copy, Plus, Edit, Trash2, RotateCcw, KeyRound, X } from 'lucide-react';
import List from './component/list/list';

function AdminOtpDevices() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    const MyData = useSelector((state) => { return state.MyData })

    const [message, setMessage] = useState("")
    const [devices, setDevices] = useState([])
    const [reload, setReload] = useState(false)
    const [registerModal, setRegisterModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [selectedDevice, setSelectedDevice] = useState(null)
    const [deleteModal, setDeleteModal] = useState(false)
    const [deviceToDelete, setDeviceToDelete] = useState(null)
    const [deactivateModal, setDeactivateModal] = useState(false)
    const [deviceToDeactivate, setDeviceToDeactivate] = useState(null)
    const [reactivateModal, setReactivateModal] = useState(false)
    const [deviceToReactivate, setDeviceToReactivate] = useState(null)

    useEffect(() => {
        dispatch(changeHeaderTitle("OTP 기기 관리"))
        dispatch(change_Current_Location("OTP 기기 관리"))
        DeviceList()
    }, [reload])

    const DeviceList = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/auth/admin/otp/devices`, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setDevices(tmp.data?.devices ?? []);
            }
            else {
                setMessage({ msg: "기기 목록 조회에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "기기명", "width": "150px", "textAlign": "center" },
        { "no": 2, "text": "상태", "width": "80px", "textAlign": "center" },
        { "no": 3, "text": "등록일시", "width": "150px", "textAlign": "center" },
        { "no": 4, "text": "마지막 사용일시", "width": "150px", "textAlign": "center" },
        { "no": 5, "text": "등록 IP", "width": "120px", "textAlign": "center" },
        { "no": 6, "text": "관리", "width": "200px", "textAlign": "center" },
    ]

    const [combineData, setCombineData] = useState([])

    useEffect(() => {
        let tableBodyData = [];
        if (devices) {
            for (let i = 0; i < devices.length; i++) {
                let data = devices[i];
                let row = [
                    { "no": 1, "text": data.device_name, "width": "150px", "textAlign": "center" },
                    { "no": 2, "text": data.is_active === "Y" ? "활성" : "비활성", "width": "80px", "textAlign": "center" },
                    { "no": 3, "text": data.registered_at || "-", "width": "150px", "textAlign": "center" },
                    { "no": 4, "text": data.last_used_at || "-", "width": "150px", "textAlign": "center" },
                    { "no": 5, "text": data.registered_ip || "-", "width": "120px", "textAlign": "center" },
                    {
                        "no": 6, "text": (
                            <div style={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                                <button
                                    className="btn btn-primary"
                                    style={{ padding: "4px 8px", fontSize: "12px" }}
                                    onClick={() => {
                                        setSelectedDevice(data);
                                        setEditModal(true);
                                    }}
                                    disabled={data.is_active === "N"}
                                >
                                    <Edit size={14} />
                                </button>
                                {data.is_active === "Y" ? (
                                    <button
                                        className="btn btn-danger"
                                        style={{ padding: "4px 8px", fontSize: "12px" }}
                                        onClick={() => handleDeactivateClick(data.id)}
                                    >
                                        <Trash2 size={14} />
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-success"
                                        style={{ padding: "4px 8px", fontSize: "12px" }}
                                        onClick={() => handleReactivateClick(data.id)}
                                    >
                                        <RotateCcw size={14} />
                                    </button>
                                )}
                                <button
                                    className="btn btn-danger"
                                    style={{ padding: "4px 8px", fontSize: "12px", backgroundColor: "#dc3545", borderColor: "#dc3545" }}
                                    onClick={() => handleDeleteClick(data.id)}
                                    title="기기 삭제"
                                >
                                    <X size={14} />
                                </button>
                            </div>
                        ), "width": "250px", "textAlign": "center"
                    },
                ]
                tableBodyData.push(row)
            }
            setCombineData(tableBodyData)
        }
    }, [devices])

    const handleDeactivateClick = (deviceId) => {
        if (!window.confirm("이 기기를 비활성화하시겠습니까?")) return;
        setDeviceToDeactivate(deviceId);
        setDeactivateModal(true);
    }

    const handleDeactivate = async (otpToken) => {
        if (!otpToken || otpToken.length !== 6) {
            setMessage({ msg: "OTP 코드를 입력해주세요. (6자리 숫자)" })
            return;
        }

        if (!deviceToDeactivate) return;

        await axios.delete(process.env.REACT_APP_API + `/api/auth/admin/otp/devices/${deviceToDeactivate}`, {
            data: {
                otpToken: otpToken
            },
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "기기 비활성화에 성공했습니다." })
                setReload(e => !e)
                setDeactivateModal(false)
                setDeviceToDeactivate(null)
            }
            else {
                setMessage({ msg: tmp.msg || "기기 비활성화에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "기기 비활성화 중 오류가 발생했습니다." })
        });
    }

    const handleReactivateClick = (deviceId) => {
        setDeviceToReactivate(deviceId);
        setReactivateModal(true);
    }

    const handleReactivate = async (otpToken) => {
        if (!otpToken || otpToken.length !== 6) {
            setMessage({ msg: "OTP 코드를 입력해주세요. (6자리 숫자)" })
            return;
        }

        if (!deviceToReactivate) return;

        await axios.post(process.env.REACT_APP_API + `/api/auth/admin/otp/devices/${deviceToReactivate}/reactivate`, {
            otpToken: otpToken
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "기기 재활성화에 성공했습니다." })
                setReload(e => !e)
                setReactivateModal(false)
                setDeviceToReactivate(null)
            }
            else {
                setMessage({ msg: tmp.msg || "기기 재활성화에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "기기 재활성화 중 오류가 발생했습니다." })
        });
    }

    const handleDeleteClick = (deviceId) => {
        if (!window.confirm("이 기기를 완전히 삭제하시겠습니까?\n삭제된 기기는 복구할 수 없습니다.")) return;
        setDeviceToDelete(deviceId);
        setDeleteModal(true);
    }

    const handleDelete = async (otpToken) => {
        if (!otpToken || otpToken.length !== 6) {
            setMessage({ msg: "OTP 코드를 입력해주세요. (6자리 숫자)" })
            return;
        }

        if (!deviceToDelete) return;

        await axios.delete(process.env.REACT_APP_API + `/api/auth/admin/otp/devices/${deviceToDelete}`, {
            data: {
                otpToken: otpToken
            },
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage({ msg: "기기 삭제에 성공했습니다." })
                setReload(e => !e)
                setDeleteModal(false)
                setDeviceToDelete(null)
            }
            else {
                setMessage({ msg: tmp.msg || "기기 삭제에 실패했습니다." })
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "기기 삭제 중 오류가 발생했습니다." })
        });
    }

    return (
        <div style={{ padding: "20px", marginTop: "52px" }}>
            <MessageModal message={message} />
            
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h2>OTP 기기 관리</h2>
                <button
                    className="btn btn-primary"
                    onClick={() => setRegisterModal(true)}
                    disabled={devices.filter(d => d.is_active === "Y").length >= 5}
                >
                    <Plus size={16} style={{ marginRight: "5px" }} />
                    기기 등록
                </button>
            </div>

            {devices.filter(d => d.is_active === "Y").length >= 5 && (
                <div style={{ 
                    padding: "10px", 
                    backgroundColor: "#fff3cd", 
                    border: "1px solid #ffc107", 
                    borderRadius: "4px",
                    marginBottom: "20px"
                }}>
                    최대 5개 기기까지 등록 가능합니다.
                </div>
            )}

            <List
                tableHeaderData={tableHeaderData}
                tableBodyData={devices ?? []}
                filter_tableBodyData={combineData}
                page={1}
                setPage={() => {}}
                maxFirstPage={Math.max(devices.length, 1)}
                nonePage={true}
            />

            {registerModal && (
                <RegisterDeviceModal
                    setModal={setRegisterModal}
                    setMessage={setMessage}
                    setReload={setReload}
                />
            )}

            {editModal && selectedDevice && (
                <EditDeviceModal
                    setModal={setEditModal}
                    setMessage={setMessage}
                    setReload={setReload}
                    device={selectedDevice}
                />
            )}

            {deleteModal && (
                <DeleteDeviceModal
                    setModal={setDeleteModal}
                    setMessage={setMessage}
                    handleDelete={handleDelete}
                />
            )}
            {deactivateModal && (
                <OtpVerifyModal
                    setModal={setDeactivateModal}
                    setMessage={setMessage}
                    handleVerify={handleDeactivate}
                    title="기기 비활성화"
                    actionText="비활성화"
                    actionColor="#dc3545"
                />
            )}
            {reactivateModal && (
                <OtpVerifyModal
                    setModal={setReactivateModal}
                    setMessage={setMessage}
                    handleVerify={handleReactivate}
                    title="기기 재활성화"
                    actionText="재활성화"
                    actionColor="#28a745"
                />
            )}
        </div>
    )
}

function RegisterDeviceModal({ setModal, setMessage, setReload }) {
    const [deviceName, setDeviceName] = useState("")
    const [otpData, setOtpData] = useState(null)
    const [deviceId, setDeviceId] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [otpToken, setOtpToken] = useState("")
    const [isVerifying, setIsVerifying] = useState(false)
    const [isVerified, setIsVerified] = useState(false)
    const [localMessage, setLocalMessage] = useState("")

    const onSubmit = async () => {
        if (!deviceName.trim()) {
            setLocalMessage({ msg: "기기 이름을 입력해주세요." })
            return
        }

        if (isSubmitting) return
        setIsSubmitting(true)

        try {
            // 기기 정보 수집
            const deviceInfo = {
                browser: navigator.userAgent,
                platform: navigator.platform,
            }

            await axios.post(process.env.REACT_APP_API + "/api/auth/admin/otp/register-device", {
                deviceName: deviceName.trim(),
                deviceInfo: deviceInfo
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setOtpData(tmp.data)
                    setDeviceId(tmp.data?.deviceId || null)
                    setLocalMessage({ msg: "기기 등록 성공. QR 코드를 스캔하거나 수동으로 입력해주세요." })
                }
                else {
                    setLocalMessage({ msg: tmp.msg || "기기 등록에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
                setLocalMessage({ msg: "기기 등록 중 오류가 발생했습니다." })
            });
        } finally {
            setIsSubmitting(false)
        }
    }

    const onVerifyOtp = async () => {
        if (!otpToken || otpToken.length !== 6) {
            setLocalMessage({ msg: "올바른 OTP 코드를 입력해주세요. (6자리 숫자)" })
            return
        }

        if (isVerifying) return
        setIsVerifying(true)

        try {
            await axios.post(process.env.REACT_APP_API + "/api/auth/admin/otp/verify", {
                token: otpToken,
                deviceId: deviceId
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000 && tmp?.data?.success !== false) {
                    setIsVerified(true)
                    setLocalMessage({ msg: "OTP 검증 성공! 기기가 등록되었습니다." })
                }
                else {
                    // 실패 응답 처리 (code >= 2000 또는 success: false)
                    setLocalMessage({ msg: tmp.msg || "OTP 검증에 실패했습니다. 다시 시도해주세요." })
                    setOtpToken("")
                }
            }).catch(error => {
                console.error(error);
                setLocalMessage({ msg: "OTP 검증 중 오류가 발생했습니다." })
                setOtpToken("")
            });
        } finally {
            setIsVerifying(false)
        }
    }

    const changeOtpToken = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 6) {
            setOtpToken(value);
        }
    }

    return (
        <>
            <MessageModal message={localMessage} />
            <div id="submerchants-modal" className="modal show_modal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content marginTop30 modal_sty">
                        <div className="modal-header">
                            <h2 className="font-medium mr-auto modal_title_sty">OTP 기기 등록</h2>
                        <button
                            type="button"
                            className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                            onClick={() => {
                                setModal(false)
                                if (otpData) {
                                    setReload(e => !e)
                                }
                            }}
                        >
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ padding: "20px" }}>
                        {!otpData ? (
                            <>
                                <div style={{ marginBottom: "15px" }}>
                                    <label className="form-label">기기 이름</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="예: iPhone 14, Galaxy S23"
                                        value={deviceName}
                                        onChange={(e) => setDeviceName(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                onSubmit();
                                            }
                                        }}
                                    />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="submit"
                                        className="btn btn-primary w-20 reg_btn"
                                        onClick={onSubmit}
                                        disabled={isSubmitting}
                                    >
                                        등록
                                    </button>
                                    <input
                                        type="button"
                                        className="btn btn-primary w-20 close_btn"
                                        onClick={() => setModal(false)}
                                        style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                                        value="취소"
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "20px" }}>
                                    {otpData.qrCodeImage ? (
                                        <img 
                                            src={otpData.qrCodeImage} 
                                            alt="OTP QR Code" 
                                            style={{ width: '200px', height: '200px', border: '1px solid #e1e1e1', borderRadius: '4px' }}
                                        />
                                    ) : (
                                        <div style={{ width: '200px', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e1e1e1', borderRadius: '4px' }}>
                                            QR 코드 생성 중...
                                        </div>
                                    )}
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                        <div>{otpData.manualEntryKey ?? otpData.secret ?? ""}</div>
                                        <CopyToClipboard text={otpData.manualEntryKey ?? otpData.secret ?? ""}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => setLocalMessage({ msg: "복사 성공" })}>
                                                <Copy size={15} />
                                            </div>
                                        </CopyToClipboard>
                                    </div>
                                    <div style={{ textAlign: "center", color: "#666", fontSize: "14px" }}>
                                        Google Authenticator 앱에서 QR 코드를 스캔하거나<br />
                                        위의 키를 수동으로 입력해주세요.
                                    </div>
                                    {!isVerified && (
                                        <>
                                            <div style={{ width: "100%", marginTop: "10px" }}>
                                                <label className="form-label">OTP 코드 입력 (6자리)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="000000"
                                                    maxLength={6}
                                                    value={otpToken}
                                                    onChange={changeOtpToken}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' && otpToken.length === 6) {
                                                            onVerifyOtp();
                                                        }
                                                    }}
                                                    style={{ textAlign: "center", fontSize: "18px", letterSpacing: "4px" }}
                                                />
                                            </div>
                                            {isVerified && (
                                                <div style={{ color: "#28a745", fontWeight: "bold", marginTop: "10px" }}>
                                                    ✓ 검증 완료
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {isVerified && (
                                        <div style={{ 
                                            padding: "10px", 
                                            backgroundColor: "#d4edda", 
                                            border: "1px solid #c3e6cb", 
                                            borderRadius: "4px",
                                            color: "#155724",
                                            textAlign: "center"
                                        }}>
                                            OTP 검증이 완료되었습니다.
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    {!isVerified ? (
                                        <>
                                            <button
                                                type="button"
                                                className="btn btn-primary w-20 reg_btn"
                                                onClick={onVerifyOtp}
                                                disabled={isVerifying || otpToken.length !== 6}
                                            >
                                                {isVerifying ? "검증 중..." : "검증"}
                                            </button>
                                            <input
                                                type="button"
                                                className="btn btn-primary w-20 close_btn"
                                                onClick={() => {
                                                    setModal(false)
                                                    if (otpData) {
                                                        setReload(e => !e)
                                                    }
                                                }}
                                                style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                                                value="취소"
                                            />
                                        </>
                                    ) : (
                                        <input
                                            type="button"
                                            className="btn btn-primary w-20 close_btn"
                                            onClick={() => {
                                                setModal(false)
                                                setReload(e => !e)
                                            }}
                                            style={{ backgroundColor: '#28a745', border: 'none' }}
                                            value="완료"
                                        />
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

function EditDeviceModal({ setModal, setMessage, setReload, device }) {
    const [deviceName, setDeviceName] = useState(device.device_name)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        setDeviceName(device.device_name)
    }, [device])

    const onSubmit = async () => {
        if (!deviceName.trim()) {
            setMessage({ msg: "기기 이름을 입력해주세요." })
            return
        }

        if (isSubmitting) return
        setIsSubmitting(true)

        try {
            await axios.put(process.env.REACT_APP_API + `/api/auth/admin/otp/devices/${device.id}`, {
                deviceName: deviceName.trim()
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setMessage({ msg: "기기 정보 수정에 성공했습니다." })
                    setReload(e => !e)
                    setModal(false)
                }
                else {
                    setMessage({ msg: tmp.msg || "기기 정보 수정에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div id="submerchants-modal" className="modal show_modal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium mr-auto modal_title_sty">기기 정보 수정</h2>
                        <button
                            type="button"
                            className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                            onClick={() => setModal(false)}
                        >
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ padding: "20px" }}>
                        <div style={{ marginBottom: "15px" }}>
                            <label className="form-label">기기 이름</label>
                            <input
                                type="text"
                                className="form-control"
                                value={deviceName}
                                onChange={(e) => setDeviceName(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onSubmit();
                                    }
                                }}
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                type="submit"
                                className="btn btn-primary w-20 reg_btn"
                                onClick={onSubmit}
                                disabled={isSubmitting}
                            >
                                수정
                            </button>
                            <input
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={() => setModal(false)}
                                style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                                value="취소"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function DeleteDeviceModal({ setModal, setMessage, handleDelete }) {
    const [otpToken, setOtpToken] = useState("")
    const [isDeleting, setIsDeleting] = useState(false)
    const [localMessage, setLocalMessage] = useState("")

    const changeOtpToken = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 6) {
            setOtpToken(value);
        }
    }

    const onDelete = async () => {
        if (!otpToken || otpToken.length !== 6) {
            setLocalMessage({ msg: "OTP 코드를 입력해주세요. (6자리 숫자)" })
            return
        }

        if (isDeleting) return
        setIsDeleting(true)

        try {
            await handleDelete(otpToken)
        } finally {
            setIsDeleting(false)
        }
    }

    return (
        <>
            <MessageModal message={localMessage} />
            <div id="submerchants-modal" className="modal show_modal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content marginTop30 modal_sty">
                        <div className="modal-header">
                            <h2 className="font-medium mr-auto modal_title_sty">OTP 기기 삭제</h2>
                            <button
                                type="button"
                                className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                                onClick={() => {
                                    setModal(false)
                                    setOtpToken("")
                                }}
                            >
                                <span className="w-4 h-4 flex items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <div style={{ padding: "20px" }}>
                            <div style={{ marginBottom: "20px" }}>
                                <p style={{ color: "#dc3545", fontWeight: "600", marginBottom: "10px" }}>
                                    ⚠️ 경고: 기기를 삭제하면 복구할 수 없습니다.
                                </p>
                                <p style={{ color: "#666", fontSize: "14px" }}>
                                    삭제를 진행하려면 OTP 코드를 입력해주세요.
                                </p>
                            </div>
                            <div style={{ marginBottom: "20px" }}>
                                <label className="form-label">OTP 코드 (6자리)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="000000"
                                    maxLength={6}
                                    value={otpToken}
                                    onChange={changeOtpToken}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && otpToken.length === 6 && !isDeleting) {
                                            onDelete();
                                        }
                                    }}
                                    style={{ textAlign: "center", fontSize: "18px", letterSpacing: "4px", padding: "12px" }}
                                    disabled={isDeleting}
                                    autoFocus
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-danger w-20 reg_btn"
                                onClick={onDelete}
                                disabled={isDeleting || !otpToken || otpToken.length !== 6}
                                style={{ backgroundColor: '#dc3545', border: 'none', color: 'white' }}
                            >
                                {isDeleting ? "삭제 중..." : "삭제"}
                            </button>
                            <input
                                type="button"
                                className="btn btn-primary w-20 close_btn"
                                onClick={() => {
                                    setModal(false)
                                    setOtpToken("")
                                }}
                                style={{ backgroundColor: '#6c757d', marginLeft: '10px', border: 'none' }}
                                value="취소"
                                disabled={isDeleting}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function OtpVerifyModal({ setModal, setMessage, handleVerify, title, actionText, actionColor }) {
    const [otpToken, setOtpToken] = useState("")
    const [isProcessing, setIsProcessing] = useState(false)

    const changeOtpToken = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 6) {
            setOtpToken(value);
        }
    }

    const onVerify = async () => {
        if (!otpToken || otpToken.length !== 6) {
            setMessage({ msg: "OTP 코드를 입력해주세요. (6자리 숫자)" })
            return
        }

        if (isProcessing) return
        setIsProcessing(true)

        try {
            await handleVerify(otpToken)
        } finally {
            setIsProcessing(false)
        }
    }

    return (
        <div id="submerchants-modal" className="modal show_modal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium mr-auto modal_title_sty">{title}</h2>
                        <button
                            type="button"
                            className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty"
                            onClick={() => {
                                setModal(false)
                                setOtpToken("")
                            }}
                        >
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ padding: "20px" }}>
                        <div style={{ marginBottom: "20px" }}>
                            <p style={{ color: "#666", fontSize: "14px" }}>
                                {actionText}을(를) 진행하려면 OTP 코드를 입력해주세요.
                            </p>
                        </div>
                        <div style={{ marginBottom: "20px" }}>
                            <label className="form-label">OTP 코드 (6자리)</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="000000"
                                maxLength={6}
                                value={otpToken}
                                onChange={changeOtpToken}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && otpToken.length === 6 && !isProcessing) {
                                        onVerify();
                                    }
                                }}
                                style={{ textAlign: "center", fontSize: "18px", letterSpacing: "4px" }}
                                disabled={isProcessing}
                                autoFocus
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn w-20 reg_btn"
                            onClick={onVerify}
                            disabled={isProcessing || !otpToken || otpToken.length !== 6}
                            style={{ backgroundColor: actionColor, border: 'none', color: 'white' }}
                        >
                            {isProcessing ? "처리 중..." : actionText}
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => {
                                setModal(false)
                                setOtpToken("")
                            }}
                            style={{ backgroundColor: '#6c757d', marginLeft: '10px', border: 'none' }}
                            value="취소"
                            disabled={isProcessing}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminOtpDevices;

